module.exports = __webpack_public_path__ + "img/SKMJ_place11.56936305.jpg";